<template>
  <div class="spinner">
    <div class="spinner-container">
      <svg viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.spinner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &-container {
    width: toRem(20);
  }

  svg {
    width: 100%;
    height: 100%;
    animation: rotate 2s linear infinite;

    circle {
      stroke: themeColor('primary');
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
